<template>
  <div class="pb100">
    <banner/>
    <crumbs/>
    <div class="container">
      <type-screen modelType="cultureshow" :menu-id="this.$route.query.columnId" @typeObj="selectType"/>
      <el-button type="primary" @click="dialogFormVisible = true">上传视频</el-button>
      <ul class="ul-model6 clearfix mt20">
        <li @click.stop="detaillink(item.menuId, item.id, item.videoUrl)" v-for="(item, index) in List" :key="index">
          <a class="clearfix">
            <div class="imgbox">
              <img class="imgtop" :src="getImage(item.image)" alt="">
            </div>
            <div class="txtbox">
              <h2 class="textover">{{ item.videoName}}</h2>
            </div>
          </a>
        </li>
      </ul>
      <nodata v-show="nodataflag"/>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="Param.limit"
        :pager-count="5"
        :current-page.sync="currentPage"
        layout="prev, pager, next"
        :total="listTotal"
        class="pagemodel1">
      </el-pagination>
      <el-dialog title="上传须知" :visible.sync="dialogFormVisible" center :width="addformWidth">
        <el-form ref="cultureshowForm" :model="cultureshowForm" :rules="cultureshowRules" label-position="left" label-width="80px">
          <el-form-item label="姓名" prop="userName">
            <el-input v-model="cultureshowForm.userName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="contact">
            <el-input v-model="cultureshowForm.contact" placeholder="请输入联系方式"></el-input>
          </el-form-item>
          <el-form-item label="视频名称" prop="videoName">
            <el-input v-model="cultureshowForm.videoName" placeholder="请输入视频名称"></el-input>
          </el-form-item>
          <el-form-item label="封面图片">
            <ctmsp-images-upload
              :limit="1"
              :max-size="2"
              :id="cultureshowForm.id"
              :folder="cultureshowForm.departmentCode +'/cultureshow/'"
              :image-list="imageList"
              upload-api="/upload"
              file-type="picture"
              routing-key="cultureshow"
              @imagePath="setImageList"/>
            <span style="color: red">*Jpg/png格式，小于2M</span>
          </el-form-item>
          <el-form-item label="链接" prop="videoUrl">
            <el-input v-model="cultureshowForm.videoUrl" placeholder="如果您不需要上传，且拥有视频地址，可直接填写地址" />
          </el-form-item>
          <el-form-item label="上传视频">
            <ctmsp-one-video-upload
              :id="cultureshowForm.id"
              :max-size="500"
              :file-name="cultureshowForm.videoUrl"
              :folder="cultureshowForm.departmentCode +'/cultureshow/'"
              upload-api="/upload"
              file-type="video"
              routing-key="cultureshow"
              @videoPath="setVideoPath"/>
          </el-form-item>
          <el-form-item prop="accept">
            <el-checkbox-group v-model="cultureshowForm.accept" @change="btnchange()">
              <el-checkbox label="我已阅读并悉知上传流程。" name="accept"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addevent">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import typeScreen from '@/components/typescreen/index'
import { getCultureShowList, addCultureShow } from '@/api/cultureshow/index'
import { scrollAnimation } from '@/utils/index'
import nodata from '@/components/nodata/index'
import { timeFormat } from '@/utils/validate'
import CtmspImagesUpload from '@/components/Upload/CtmspImagesUpload'
import CtmspOneVideoUpload from '@/components/Upload/CtmspOneVideoUpload'
export default {
  name: 'cultureshow',
  meta: {
    showHeader: true
  },
  components: {
    typeScreen,
    crumbs,
    nodata,
    banner,
    CtmspImagesUpload,
    CtmspOneVideoUpload
  },
  data () {
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(this.$message.error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      Param: {
        page: 1,
        limit: 12,
        menuId: this.$route.query.columnId,
        customTypeId: ''
      },
      currentPage: 1,
      nodataflag: false,
      List: [],
      listTotal: 0,
      addformWidth: '52%',
      dialogFormVisible: false,
      cultureshowForm: {
        userName: '',
        contact: '',
        videoName: '',
        image: '',
        videoUrl: '',
        menuId: this.$route.query.columnId,
        departmentCode: this.$cookie.get('museumCode'),
        accept: [],
        id: undefined
      },
      cultureshowRules: {
        userName: [{required: true, message: '请输入姓名', trigger: 'blur'}],
        contact: [{required: true, validator: checkPhone, trigger: 'blur'}],
        videoName: [{required: true, message: '请输入视频名称', trigger: 'blur'}],
        image: [{required: true, message: '请输入视频名称', trigger: 'blur'}],
        videoUrl: [{required: true, message: '请输入视频名称', trigger: 'blur'}]
      },
      imageList: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getTime (val) {
      return timeFormat(val, 'yymmddhhmm')
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    getList () {
      getCultureShowList(this.Param).then(res => {
        if (res.data.status === 200) {
          this.listTotal = res.data.data.total
          if (this.listTotal === 0) {
            this.nodataflag = true
          } else {
            this.nodataflag = false
          }
          this.List = res.data.data.rows
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    /* 筛选条件 */
    selectType (obj) {
      this.Param.customTypeId = obj.customTypeId
      this.Param.page = 1
      this.currentPage = 1
      this.getList()
    },
    // 分页触发
    handleCurrentChange (val) {
      this.Param.page = val
      const currentY = document.documentElement.scrollTop || document.body.scrollTop
      scrollAnimation(currentY, 0)
      this.getList()
    },
    detaillink (columnId, id, videoUrl) {
      if (videoUrl.indexOf('.html') > -1) {
        window.open(videoUrl)
      } else {
        this.$router.push({path: '/cultureshowdetail', query: {columnId: columnId, id: id}})
      }
    },
    setImageList (val) {
      this.cultureshowForm.image = val
    },
    setVideoPath (val) {
      this.cultureshowForm.videoUrl = val
    },
    /* 添加视频 */
    addevent () {
      this.$refs.cultureshowForm.validate((valid) => {
        if (valid) {
          if (this.cultureshowForm.image === '') {
            this.$message.error('请上传封面')
          } else {
            addCultureShow(JSON.stringify(this.cultureshowForm)).then(res => {
              if (res.data.status === 200) {
                this.$message.success('上传成功,请等待管理员审核')
                this.dialogFormVisible = false
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/cultureshow/list.vue